// extracted by mini-css-extract-plugin
module.exports = {"centerVertically":"Table_centerVertically__1jlCI","versionBox":"Table_versionBox__3Js50"};